exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quantity-select[data-v-27d09e88] {\n  max-width: inherit;\n}\ninput[type='number'][data-v-27d09e88] {\n  -moz-appearance: textfield;\n}\ninput[type='number'][data-v-27d09e88]::-webkit-inner-spin-button, input[type='number'][data-v-27d09e88]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n", ""]);

// exports
